import { Col, Divider, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import PageHelp from '../Page/PageHelp';
import Page from '../Page/Page';

const LayoutLeftMenu = (props: any) => {
    return <Page className="layout-left-menu-page">
        {/* A header of its own (like an event's) replaces the plain title on top. */}
        {props.header ? props.header : <>
            {props.hasTitleTop && !props.titleTop ? <Title>&nbsp;</Title> : ""}
            {props.titleTop ? <Title>{props.titleTop}</Title> : ""}
        </>}
        <Row align="top">
            <Col xs={24} md={6} lg={4} className='leftMenu layout-left-menu-nav'>
                {props.menu}
            </Col>
            {props.fullpageMain ? props.children :
                <Col xs={24} md={18} lg={19} className='bookyBox layout-left-menu-main'>
                    <Space style={{ width: '100%', justifyContent: 'left', margin: 0 }}>
                        <Title>{props.title}</Title>
                        <PageHelp>
                            {props.pageHelpContent}
                        </PageHelp>
                    </Space>
                    {props.children}
                </Col>}
        </Row>
        <Divider />
    </Page>
};

export default LayoutLeftMenu;